import { cx } from "class-variance-authority";
import { formatarMoedaBR } from "../../utils/formatacao-monetaria";
import { ItemCardProps } from "../../demonstrativo-extrato-bancario.types";

export function ItemCard({ label, value, classes }: ItemCardProps) {
  return (
    <div className="flex flex-col justify-center bg-[#121c35] min-w-56 h-20 px-5 rounded-lg">
      <span className="text-sm text-gray-400 mb-1">{label}</span>
      <span className={cx("text-lg font-bold", classes)}>{formatarMoedaBR(value)}</span>
    </div>
  );
}